import React, { memo } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import cls from './Requisites.module.css';
import { useRequisites } from './useRequisites';
import { DaData } from '../../../../../../components/newUI/DaData/DaData';
import { Icon } from '../../../../../../components/newUI/Icon/Icon';
import { Input } from '../../../../../../components/newUI/Input/Input';
import { Customer } from '../../../../types/dashboardInformation';

interface RequisitesProps {
    classes?: string;
    form: Customer;
    onForm: (name: string, value: string) => void;
}

export const Requisites = memo(({ classes, onForm, form }: RequisitesProps) => {
    const { t } = useTranslation();

    return (
        <div className={classNames(cls.Requisites, [classes])}>
            <DaData
                isSmartPosition
                value={form.full_name ? form.full_name : ''}
                label={t('Requisites.return.DaData.label')}
                placeholder={t('Requisites.return.DaData.placeholder')}
                errorMessage=""
                inputName="full_name"
                onChange={onForm}
                maxLength={64}
                icon={<Icon iconName="search" />}
            />
            <Input
                value={form.legal_address ? form.legal_address : ''}
                label={t('Requisites.return.inputLegalAddress.label')}
                errorMessage=""
                inputName="legal_address"
                onChange={onForm}
                maxLength={255}
            />
            <Input
                value={form.passport ? form.passport : ''}
                label={t('Requisites.return.inputPassport.label')}
                errorMessage=""
                inputName="passport"
                onChange={onForm}
                maxLength={64}
            />
            <div className={cls.inputRow}>
                <DaData
                    isSmartPosition
                    classes={cls.inputRowItem}
                    value={form.inn ? form.inn : ''}
                    label={t('Requisites.return.DaData.inn.label')}
                    errorMessage=""
                    inputName="inn"
                    onChange={onForm}
                    maxLength={64}
                    icon={<Icon iconName="search" />}
                />
                <Input
                    value={form.kpp ? form.kpp : ''}
                    label={t('Requisites.return.inputKpp.label')}
                    errorMessage=""
                    inputName="kpp"
                    onChange={onForm}
                    maxLength={64}
                    classes={cls.inputRowItem}
                />
            </div>
            <div className={cls.inputRow}>
                <DaData
                    isSmartPosition
                    classes={cls.inputRowItem}
                    value={form.ogrn ? form.ogrn : ''}
                    label={t('Requisites.return.DaData.ogrn.label')}
                    errorMessage=""
                    inputName="ogrn"
                    onChange={onForm}
                    maxLength={64}
                    icon={<Icon iconName="search" />}
                />
                <DaData
                    isSmartPosition
                    classes={cls.inputRowItem}
                    value={form.ogrnip ? form.ogrnip : ''}
                    label={t('Requisites.return.DaData.ogrnip.label')}
                    errorMessage=""
                    inputName="ogrnip"
                    onChange={onForm}
                    maxLength={64}
                    icon={<Icon iconName="search" />}
                />
            </div>
            <div className={cls.inputRow}>
                <Input
                    value={form.okpo ? form.okpo : ''}
                    label={t('Requisites.return.inputOkpo.label')}
                    errorMessage=""
                    inputName="okpo"
                    onChange={onForm}
                    maxLength={64}
                    classes={cls.inputRowItem}
                />
            </div>
            <div className={classNames(cls.inputRow, cls.withBorder)}>
                <DaData
                    isSmartPosition
                    classes={cls.inputRowItem}
                    value={form.bik ? form.bik : ''}
                    label={t('Requisites.return.DaData.bik.label')}
                    errorMessage=""
                    inputName="bik"
                    onChange={onForm}
                    maxLength={64}
                    icon={<Icon iconName="search" />}
                />
                <Input
                    value={
                        form.correspondent_account_number ? form.correspondent_account_number : ''
                    }
                    label={t('Requisites.return.inputCorrespondent.label')}
                    placeholder=""
                    errorMessage=""
                    inputName="correspondent_account_number"
                    onChange={onForm}
                    maxLength={64}
                    classes={cls.inputRowItem}
                />
            </div>
            <Input
                value={form.bank ? form.bank : ''}
                label={t('Requisites.return.inputBank.label')}
                errorMessage=""
                inputName="bank"
                onChange={onForm}
                maxLength={64}
            />
            <Input
                value={form.current_account_number ? form.current_account_number : ''}
                label={t('Requisites.return.inputCurrentAccountNumber.label')}
                errorMessage=""
                inputName="current_account_number"
                onChange={onForm}
                maxLength={64}
            />
        </div>
    );
});
